export const validEnvs = ['development', 'production', 'staging'] as const
export type Env = (typeof validEnvs)[number]

export interface EnvConfig {
  sentry: {
    dsn: string
    enabled: boolean
  }
  algoliaIndex: {
    voice: string
    soundDesign: string
    soundEffect: string
  }
  apiBaseUrl: string
  apiV3BaseUrl: string
  apiAuthBaseUrl: string
  managementBaseUrl: string
  billingBaseUrl: string
  featureFlag: {
    forcedAlgoliaProApiKey: string | undefined
  }
}

const ProductionEnvConfig: EnvConfig = {
  algoliaIndex: {
    voice: 'voices_prod',
    soundDesign: 'sound_templates_prod',
    soundEffect: 'sound_effects_prod',
  },
  sentry: {
    enabled: true,
    dsn: 'https://d661e669156d419654ef7e7bb7708bd3@o297647.ingest.us.sentry.io/4509400128421888',
  },
  apiBaseUrl: 'https://v2.api.audio',
  apiV3BaseUrl: 'https://v2.api.audio/v3',
  apiAuthBaseUrl: 'https://iam.audiostack.ai/v4',
  managementBaseUrl: 'https://users.audiostack.ai',
  billingBaseUrl: 'https://billing.audiostack.ai',
  featureFlag: {
    forcedAlgoliaProApiKey: undefined,
  },
}

const StagingEnvConfig: EnvConfig = {
  algoliaIndex: {
    voice: 'voices_staging',
    soundDesign: 'sound_templates_staging',
    soundEffect: 'sound_effects_staging',
  },
  sentry: {
    enabled: true,
    dsn: 'https://a265bc03522bd071b6e9b9271df1e89f@o297647.ingest.us.sentry.io/4509400130977792',
  },
  apiBaseUrl: 'https://staging-v2.api.audio',
  apiV3BaseUrl: 'https://staging-v2.api.audio/v3',
  apiAuthBaseUrl: 'https://staging-iam.audiostack.ai/v4',
  managementBaseUrl: 'https://staging-users.audiostack.ai',
  billingBaseUrl: 'https://staging-billing.audiostack.ai',
  featureFlag: {
    forcedAlgoliaProApiKey: undefined,
  },
}

const EnvConfigs: Record<Env, EnvConfig> = {
  development: {
    ...StagingEnvConfig,
    sentry: {
      enabled: false,
      dsn: '',
    },
    featureFlag: {
      //forcedAlgoliaProApiKey: 'ZGI3NDliYTI1MjcxNTQ2ODUyYWJjOTIzNTViM2Q5YTVlNzdmMGI5YmQ4MzM0MDE2NmM4OTQ0YmY1NTVkYmI5NWZpbHRlcnM9dmlzaWJsZV9ieSUzQWI2MjlhMWJlLTAyNWYtNDllNS1hMTRkLWQyYTllYWU3NjE5MStPUit2aXNpYmxlX2J5JTNBb3JnJTJGU2lyb2MtNGMwMytPUit2aXNpYmxlX2J5JTNBb3JnJTJGU2lyb2MtNGMwMyUyRmFkbWluK09SK3Zpc2libGVfYnklM0Fncm91cCUyRmV2ZXJ5b25lK09SK3Zpc2libGVfYnklM0Fncm91cCUyRnByZW1pdW0=',
      forcedAlgoliaProApiKey: undefined,
    },
  },
  staging: StagingEnvConfig,
  production: ProductionEnvConfig,
}

const rawEnv = import.meta.env.MODE

const isValidEnv = (env: string): env is Env =>
  !!validEnvs.find((e) => e === env)
export const env: Env = isValidEnv(rawEnv) ? rawEnv : 'development'

export const {
  sentry,
  algoliaIndex,
  managementBaseUrl,
  billingBaseUrl,
  featureFlag,
  apiBaseUrl,
  apiV3BaseUrl,
  apiAuthBaseUrl,
} = EnvConfigs[env]
